import { translation } from '../utils/interfaces';

export const translationKz: translation = {
  homeBasic: {
    osibilling: 'eOSI',
    subtitle: 'It-КТЖ (ось, УК, ПИК, ПСК)басқарудың кез келген нысандары үшін арнайы жасалған жүйе',
    description: {
      one: '"EOSI" жүйесі толығымен автоматты түрде, ай сайын тұрғындарға үйді күтіп ұстау қызметтері үшін есептеулер жасайды, банк кабинеттерінде шоттар қояды, пәтерде төлемдерді есепке алады, төлемдерді кез келген банктің КТК шоттарына тікелей аударады, кез келген уақытта кез келген құрылғыда тұрғындардың нақты ағымдағы қарызын көрсетеді және төраға мен бухгалтерді қаражат жинау бойынша күнделікті жұмыстан толығымен босатады тұрғындардан',
      two: '“еOSI" жүйесі толығымен автоматты түрде, ай сайын барлық МИБ қызметтері бойынша тұрғындарға есептеулер жасайды, банк кабинеттерінде шоттар ұсынайды, әр пәтер бойынша төлемдерді есепке алуды жүргізеді, төлемдерді тікелей банктен МИБ шоттарына есептейді, кез келген уақытта МИБ алдында тұрғындардың нақты ағымдағы берешегін көрсетеді'
    },
    services: {
      first: {
        title: 'Биллинг',
        smallTitle: '(Абоненттерге есептеулер, Каспий арқылы төлемдер, борышкерлермен жұмыс)',
        service1: 'Абоненттерге есептеулер',
        service2: 'МИБ-дің тарифтеуін икемді баптау',
        service3: 'Банктермен (Каспи, Халық) онлайн режимде интеграциялау',
        service4: 'Түзетулер',
        service5: 'Меншік иелері алдындағы есеп беру',
        service6: 'Процестерді автоматтандыру',
        service7: 'Мерзімі өткен берешекті өндіріп алу үшін құжаттарды қалыптастыру',
        service8: 'Түбіртектерді қалыптастыру',
        service9: 'Кез келген құрылғыдан жұмыс жасау',
        service10: 'Ыңғайлы интерфейс',
        subtitle: 'Бағасы айына бір үй-жайдан небәрі 100 теңге!'
      },
      second: {
        title: 'Бухгалтерия Кешені',
        smallTitle: '(шығындар, салық және статистикалық есептер, еңбекақыны есептеу) + биллинг',
        p1: 'Біз inbuh.kz сайтымен серіктестік келісімін жасадық және енді біз өз клиенттерімізге аутсорсингтік бухгалтерлік қызметтердің толық спектрін ұсына аламыз.',
        p2: 'Біздің серіктестер',
        p2_1: ', біздің клиенттер үшін келесі тарифтер ұсынайды:',
        p3: 'Тіркелгеннен кейін сұраныс бойынша жеке Тарифтік жоспар',
        p4: 'Биллинг қызметтері айына бір үй-жайдан 100 теңге.',
        p5: 'Мұндай қолайлы бағалар біздің жүйеде тіркелгеннен кейін кез келген төрағаға қол жетімді',
        p6: 'Мысалы: 100 пәтер + 10 төлем тапсырмасы',
        p7: 'Барлығы',
        p8: 'айына теңге!',
        l1: '10 төлем тапсырмасына дейін - айына – ',
        l2: '20 төлем тапсырмасына дейін – айына - ',
        l3: '40 төлем тапсырмасына дейін – айына - '
      }
    }
  },
  homeFeatures: {
    title: 'Ай сайын не аласыз',
    feature1: {
      title: 'төлемдерді есептеу',
      description: '"eOSI" жүйесінде меншік иелеріне төлемдерді есептеу'
    },
    feature2: {
      title: 'MTD тарифтеудің икемді параметрі',
      description:
        'КТЖ тарифтеуді икемді баптау мүмкіндігі (едендер, кіреберістер, үй-жайлардың түрлері және т. б. бойынша әртүрлі тарифтер )'
    },
    feature3: {
      title: 'Банкпен Интеграция',
      description:
        'Жүйенің банкпен толық интеграциясы ( абонент төлем жасаған кезде жарналардың әрбір түрі бойынша өзінің берешек сомасын көреді, жүргізілген төлемдер жүйеде бірден көрсетіледі)'
    },
    feature4: {
      title: 'деректерді түзету',
      description:
        'Барлық деректерді ( қарыздар, аудандар, тарифтер және т. б.) бірнеше секунд ішінде өз бетінше түзету мүмкіндігі'
    },
    feature5: {
      title: 'есеп беру',
      description:
        'Меншік иелері алдындағы есептілік ("eOSI" жүйесіне қосылған кезде тұрғындар өздерінің барлық үй-жайлары бойынша ақпаратты, борышкерлер бойынша есептілікті және КЖТ туралы басқа да ақпаратты көре алады)'
    },
    feature6: {
      title: 'процесті автоматтандыру',
      description:
        '"EOSI" жүйесіндегі процестерді толық автоматтандыру ("eOSI" жүйесіне қосылды, тұрғындардан қаражат жинау туралы алаңдаушылықты толығымен алып тастады және үйде жұмыс істеуге мүмкіндік алды )'
    },
    feature7: {
      title: 'құжаттарды қалыптастыру',
      description: 'борышкерлерден мерзімі өткен берешекті өндіріп алу үшін құжаттарды автоматты түрде қалыптастыру'
    },
    feature8: {
      title: 'ыңғайлы интерфейс',
      description: 'төрағаның электрондық Кабинетінің және үй-жай иесінің электрондық кабинетінің ыңғайлы интерфейсі'
    },
    feature9: {
      title: 'кез-келген құрылғыдан жұмыс',
      description: 'кез келген құрылғыдан электрондық кабинетпен жұмыс істеу мүмкіндігі'
    },
    feature10: {
      title: 'түбіртектерді қалыптастыру',
      description: 'бір түймені басу арқылы тұрғындарға электрондық түбіртектерді қалыптастыру мүмкіндігі'
    },
    feature11: {
      title: 'өсімпұлды автоматты түрде есептеу',
      description:
        'Жүйе автоматты түрде, барлық мемлекеттік нормалар бойынша, қайта қаржыландыру ставкасы негізінде абонентке мерзімі өткен борышқа өсімпұлды автоматты түрде есептейді'
    },
    feature12: {
      title: 'тұрғындарға есеп беру',
      description:
        'Сіздің банктен үзінді көшірме негізінде жүйе өткен кезеңдегі шығындар бойынша мемлекеттік үлгідегі нысан бойынша тұрғынға автоматты түрде есеп қалыптастырады'
    }
  },
  homeInfo: {
    title: '«eOSI» жүйесінің функциялары',
    osifeature1: 'Абоненттерге төлемдерді толығымен автоматты түрде есептейді',
    osifeature2: 'Абоненттерге электрондық және / немесе қағаз түріндегі түбіртекті жеткізуді қамтамасыз етеді',
    osifeature3:
      'Абоненттерге ең танымал банктер: Kaspi және Halyk, сондай-ақ Jusan және BCC арқылы KTY қызметтеріне ақы төлеуге мүмкіндік береді',
    osifeature4: 'Нақты уақыт режимінде абоненттердің төлемдерін көрсетеді және берешектердің есебін жүргізеді',
    osifeature5:
      'Абоненттердің берешектерін өндіріп алу үшін құжаттарды автоматтандырылған қалыптастыру бойынша кіріктірілген модулі бар',
    osifeature6: 'Төрағаның электрондық кабинетінің қарапайым және ыңғайлы интерфейсі',
    osifeature7: 'Меншік иелері алдындағы төрағаның ай сайынғы есептерін қалыптастыру блогы',
    osifeature8: 'Жақында салық есептілігін жасау мүмкіндігі енгізілетін болады',
    endTitle1: 'Бір айда тек 100 теңге аралығында тұрып, арналарды қосып алу!',
    endTitle2:
      '1000-дан асқан көп бай үшін төменгі тариф қолданылуда, толығырақ менеджерлерге хабарласуыңызды сұрау қылаймыз.'
  },
  login: {
    notRegistered: 'Тіркелмеген',
    passRegistration: 'Тіркелу',
    title: 'OSI кабинетіне кіріңіз',
    phonePlaceholder: 'Телефон нөмірін енгізіңіз',
    sixDigitsPassword: '6 саннан тұратын құпия сөзді енгізіңіз',
    registrationNotFinished: 'Тіркеу аяқталмады'
  },
  register: {
    title: 'Тіркеу',
    subtitle: 'OSI кабинетіне кіру үшін тіркеліңіз',
    offer: 'Тіркелу арқылы мен таныс екенімді растаймын',
    alreadyRegistered: 'Бұрын тіркелген',
    conditions: 'ұсыныс шарттары',
    polite: 'қауіпсіздік саясаты',
    continueRegister: 'Тіркеуді жалғастыру үшін сілтемеге өтіңіз.'
  },
  signer: {
    storage: 'Cақтау',
    sign: 'ЭЦП қол қою',
    dialogTite: 'ЭЦП құжатына қол қою',
    dialogContent:
      'ЭЦП бар құжатқа қол қою арқылы сіз енгізілген деректер мен ұсынылған құжаттардың дұрыстығын растайсыз',
    notConnectToNCAlayer: 'NcaLayer қосылымы жоқ',
    ncaLayerError: 'NCALayer қатесі',
    // OSI-763: раньше отмена в окне NCALayer никак не показывалась пользователю
    signCancelled: 'Қол қою тоқтатылды',
    signError: 'Құжатқа қол қою мүмкін болмады',
    needSignNewDoc:
      'Компанияның атауын "OSI Billing" - тен - ке ауыстыруға байланысты "eosi.kz " ЭЦҚ арқылы офертаға қайта қол қою қажет. Туындаған сұрақтар бойынша + 77076825676 Максим нөміріне хабарласуға болады',
    fetchDocError: 'Келісімшартты алу кезіндегі қате'
  },
  resetPassword: {
    title: 'Құпия сөзіңізді ұмыттыңыз ба?',
    subtitle: 'Телефон нөміріңізді енгізіңіз, біз сізге құпия сөзді қалпына келтіру кодын жібереміз',
    sixDigitCodeTG: 'Telegram ботынан 6 таңбалы кодты енгізіңіз'
  },
  roles: {
    title: 'ретінде кіру',
    abonent: 'Жазылушы',
    chairman: 'Төраға',
    trusted: 'Сенімді',
    // Карточка роли в боковом меню, когда роль не выбрана, и пункт меню аватара
    // (дефект «сброс роли на ABONENT после очистки сессии»)
    selectRole: 'Рөлді таңдаңыз',
    changeRole: 'Рөлді ауыстыру'
  },
  cabinetRoot: {
    appList: 'Өтінімдер тізімі',
    subtitle: 'Егер сіз МИБ төрағасы болсаңыз, тіркеуге өтініш беріңіз',
    sendOrder: 'Өтініш беру',
    registrationListHeader: 'МИБ тіркеуге өтінімдер',
    registrationTable: {
      created: 'Created',
      state: 'Жағдайы',
      name: 'Атауы',
      IDN: 'БСН',
      address: 'Мекен-жайы'
    },
    findOsi: 'МИБті іздеу',
    osiViewCarousel: 'Карусель',
    osiViewGrid: 'Тор',
    // OSI-806: «іздеу нәтиже бермеді» күйі. {query} — ICU-плейсхолдер, <b> — react-intl rich-text тегі.
    // Қазақ тілінде сұраныс сөйлемнің басында тұрады — сондықтан интерполяция қолданылады.
    osiNotFound: 'Табылмады',
    osiNotFoundHint: '<b>"{query}"</b> сұранысы бойынша нәтиже табылмады. Іздеу үшін басқа мәнді енгізіп көріңіз.',
    user: {
      title: 'Пайдаланушы профилі',
      main: 'Негізгі',
      changePassword: 'Құпия сөзді өзгерту',
      oldPassword: 'Ескі құпия сөз',
      newPassword: 'Жаңа құпия сөз',
      repeatNewPassword: 'Жаңа құпия сөзді қайталаңыз',
      navigation: {
        home: 'Үй',
        profile: 'Пайдаланушы профилі'
      }
    },
    registration: {
      title: 'осьті тіркеу',
      homeLink: 'үй',
      view: 'өтінімді қарау',
      re: 'осьті тіркеу',
      step1: 'тіркеу деректері',
      step2: 'құжаттар',
      step3: 'растау'
    }
  },
  osiRoot: {
    breadcrumbs: {
      begin: 'Басталуы'
    },
    navBarHeader: 'МИБ КАБИНЕТІ',
    osiInfo: 'Үй туралы ақпарат',
    osiServices: 'МИБ Техкарта',
    osiAbonents: 'Үй-Жайлар / Пәтерлер',
    osiAccurals: 'Төлемдерді есептеу',
    osiOsv: 'Сальдо',
    osiPayments: 'Төлемдер',
    // OSI-814: раздел переименован из «Бухгалтерские документы» (бух. документы станут отдельной категорией)
    osiActs: 'Орындалған жұмыстар актілері',
    osiReports: 'Есептер',
    osiDebts: 'Борышкерлерге хабарламалар',
    osiInvoices: 'Түбіртектер',
    osiForum: 'Онлайн жиналыс',
    osiInspection: 'Тұрғын үй инспекциясының хабарламалары'
  },
  osiInfo: {
    mainInfo: {
      tabTitle: 'Негізгі деректер',
      title: 'Негізгі деректер',
      docs: 'Құжаттар',
      electro: 'Меншікті электрмен жабдықтау',
      hotWater: 'Меншікті ыстық су',
      heating: 'Меншікті жылыту',
      gasified: 'Газдандырылған'
    },
    bills: {
      tabTitle: 'Шоттар',
      title: 'Шоттар',
      addBill: 'Шот-фактураны қосу',
      editBill: 'Тіркелгіні өңдеу',
      deleteBill: 'Шотты жою',
      table: {
        billType: 'Шот түрі',
        bill: 'Шот',
        IDNBank: 'Банктің БСК'
      }
    },
    companies: {
      tabTitle: 'Сервистік компаниялар',
      title: 'Сервистік компаниялар',
      addCompany: 'Сервистік компанияны қосу',
      deleteCompany: 'Сервистік компанияны жою',
      editCompany: 'қызмет көрсету компаниясын өзгерту',
      table: {
        type: 'Түрі',
        phones: 'Телефондар',
        address: 'Мекен-жайлары',
        print: 'Түбіртек бойынша басып шығару'
      }
    },
    trustedUsers: {
      tabTitle: 'Сенімді пайдаланушылар'
    }
  },
  osiAbonents: {
    addFlat: 'Бөлме/пәтер қосыңыз',
    editing: 'Өңдеу',
    table: {
      number: 'Нөмірі',
      personalAcc: 'ДШ МИБ',
      ercAcc: 'ДШ ЕРЦ',
      square: 'Алаң',
      effectiveSquare: 'Пайдалы алаң',
      floor: 'Қабат',
      name: 'Меншік иесі',
      owner: 'Иесі',
      idn: 'БСН/ИИН',
      phone: 'Телефон',
      type: 'Түрі',
      livingFact: 'Тұрады',
      livingJur: 'Тіркелген'
    },
    totalSquare: 'Жалпы алаң',
    totalRows: 'Барлық жолдар'
  },
  osiAccruals: {
    tabs: {
      plan: 'Есептеу жоспары',
      saldo: 'Абоненттердің бастапқы сальдосы'
    },
    serviceStatuses: {
      ready: 'Дайын',
      notReady: 'Дайын емес',
      inactive: 'Белсенді емес'
    },
    serviceErrors: {
      emptyTariff: 'Тарифтің сомасы көрсетілмеген',
      emptyAbonents: 'Қызмет бойынша есептеу үшін Үй-жайлар таңдалмаған'
    },
    formElements: {
      editFormTitle: 'Қызметті өңдеу',
      deleteFormTitle: 'Қызметті есептеу жоспарынан жою',
      addFormTitle: 'Қызметті есептеу жоспарына қосу',
      customServiceFormTitle: 'Қызметті құру',
      name: 'Атауы'
    },
    abonentsSelected: 'Қызметке қосылған',
    pageTitle: 'Есептеу жоспары',
    table: {
      number: 'Үй-жайдың нөмірі',
      owner: 'Үй-жайдың меншік иесі',
      saldo: 'Сальдо',
      status: 'күй',
      service: 'қызмет',
      tariff: 'Тариф',
      abonents: 'абоненттер',
      type: 'Тип',
      flat: 'Қонақүй',
      floor: 'Қабат',
      square: 'Алаң',
      parkingPlaces: 'Қарақаш қойындылары',
      residential: 'Тұрғын',
      nonResidential: 'Тұрғын емес',
      basement: 'Төменгі бағана',
      parking: 'Тұрақ',
      storage: 'Қоймалар'
    }
  },
  osiOSV: {
    // подпись чекбокса схлопывания дочерних помещений (паркинги/кладовки) в родителя
    collapseChildren: 'Еншілес үй-жайларды жию',
    tabs: {
      osi: 'МИБ',
      flats: 'Үй-жайлар',
      accruals: 'Есептеулер',
      paymentOrders: 'Төлем тапсырмаларының жиынтығы'
    },
    pageTitle: 'Айналым-сальдо ведомосы',
    table: {
      number: 'Үй-жайдың №',
      abonentName: 'Үй-жайдың меншік иесі',
      owner: 'Иесі',
      totalBegin: 'Бастапқы сальдо',
      totalDebt: 'Есептелді',
      totalFixes: 'Түзетулер',
      totalKredit: 'Төленді',
      // OSI-808: было 'жақсы' — артефакт машинного перевода английского fine («хорошо»
      // вместо «пеня»). Правильный термин для пени — «Өсімпұл».
      totalFine: 'Өсімпұл',
      totalEnd: 'Берешек',
      period: 'Кезең',
      service: 'Қызмет',
      total: 'Жалпы сомасы',
      footer: {
        startOsv: 'Бастапқы сальдо:',
        accrued: 'Есептелді:',
        fixes: 'түзетулер:',
        payed: 'Төленді:',
        // OSI-808: подпись пени в футере ОСВ и подпись строки «ИТОГО» закреплённых строк итогов
        fine: 'Өсімпұл:',
        debt: 'Берешек:',
        total: 'БАРЛЫҒЫ',
        // OSI-808: подписи кнопки сворачивания/разворачивания строк итогов по категориям услуг.
        // «санат» — категория, «көрсету» — показать, «жасыру» — скрыть.
        showCategories: 'Санаттар бойынша көрсету',
        hideCategories: 'Санаттарды жасыру'
      }
    }
  },
  osiPayments: {
    tabs: {
      payments: 'Төлемдер',
      corrections: 'Түзетулер'
    },
    pageTitle: 'Төлемдер',
    formElements: {
      createPayment: 'Төлем жасау',
      createCorrection: 'Түзету жасаңыз'
    },
    table: {
      date: 'Төлем күні',
      acceptedBank: 'Қабылданды',
      abonentName: 'Үй-жайдың иесі',
      number: 'Үй-жайдың нөмірі',
      service: 'Қызмет',
      amount: 'Сома\u00a0(теңге)',
      reason: 'Мақсаты'
    }
  },
  osiActs: {
    signedDocs: 'Қол қойылған құжаттар',
    unsignedDocs: 'Қол қоюға арналған құжаттар',
    actions: {
      sign: 'Қол қою',
      watch: 'Көру'
    },
    signAcceptContent: 'ЭЦҚ көмегімен құжатқа қол қою арқылы сіз ұсынылған деректердің дұрыстығын растайсыз'
  },
  osiDebts: {
    tabs: {
      debts: 'Алдыңғы кезеңдердегі берешектер',
      docs: 'Құжаттардың үлгілері'
    },
    newDebt: {
      buttonLabel: 'Берешек енгізу',
      title: 'Алдыңғы кезеңдердің берешегін енгізу',
      startSaldoPeriod: 'Кезеңге арналған бастапқы сальдо "',
      acceptChanged: 'Бастапқы сальдо жүйесіндегі өзгерісті растайсыз ба',
      saldoNotMatch: 'Қызметтің бастапқы сальдосы кезеңнің соңындағы қарызға сәйкес келмейді "'
    },
    docs: {
      debt: 'Борышкерге хабарлама',
      notary: 'Нотариусқа хабарлама'
    },
    table: {
      number: 'Үй-жайдың №',
      abonent: 'Абоненттің ТАӘ',
      serviceGroup: 'Қызметтер тобы',
      amount: 'Кезең үшін берешек, тг.',
      period: 'Кезең'
    }
  },
  osiInvoices: {
    tabs: {
      invoices: 'Түбіртектер',
      qr: 'QR коды',
      // «Квитанции предыдущих периодов» — вкладка ЛК жителя
      pastInvoices: 'Өткен кезеңдердің түбіртектері'
    },
    // Подпись селектора периода
    period: 'Кезең',
    table: {
      title: 'түбіртекті қалыптастыру үшін абоненттерді таңдау',
      flat: 'бөлме',
      owner: 'меншік иесі',
      areaType: 'түрі',
      id: 'LS осі',
      square: 'Алаң'
    },
    createInvoices: 'барлық түбіртектерді қалыптастыру',
    createPartialInvoices: 'жеке түбіртектерді қалыптастыру',
    create: 'Қалыптастыру',
    invoiceConstraints: 'Түбіртектерді қалыптастыру ағымдағы айдың 5-тен соңғы күніне дейін қол жетімді.',
    createQR: 'QR жасаңыз',
    telegramBot: 'eOSI.kz боты',
    telegramLinkHeader: 'Құрметті төрағалар, төмендегі мәтінді көшіріп, үйдегі чатқа жіберулеріңізді сұраймыз.',
    telegramLinkInfo1:
      'Құрметті тұрғындар, сіздің ыңғайлығыңыз үшін электрондық түбіртектерді алуға мүмкіндік туды! Ол үшін ',
    telegramLinkInfo2:
      ' сілтемесі арқылы өтіп,  пәтер нөмірін енгізіңіз! Содан кейін Сіз ай сайын телефоныңызда кез келген уақытта қолжетімді болатын ағымдағы түбіртектерді ала аласыз!',
    videoInfo: 'Электрондық түбіртектерді алу туралы бейне:',
    fetchQRError: 'QR кодын алу кезіндегі қате'
  },
  osiReports: {
    tabs: {
      systemReports: 'Жүйелік есептер',
      accountReports: 'Тұрғындарға есеп беру'
    },
    pageTitle: 'Есеп береді',
    table: {
      name: 'Есеп атауы',
      comment: 'Пікір'
    },
    dialogs: {
      selectPeriod: 'Кезеңді таңдаңыз'
    },
    reports: {
      debts: {
        name: 'Дебиторлар туралы есеп беру',
        comment:
          'Бұл есеп қазіргі уақытта мерзімі өткен берешектерді қамтиды. Берешек ағымдағы айдың 26-нан бастап мерзімі өткен болып есептеледі.'
      }
    },
    fetchReportError: 'Есепті алу қатесі'
  },
  osiWizard: {
    notification:
      'сізде пәтерлер туралы ақпарат жоқ. Әр пәтердің сол жағындағы қарындаш белгішесін басу арқылы деректерді енгізіңіз.',
    steps: {
      step1: 'МИБ туралы мәліметтер',
      step2: 'қызмет көрсететін компаниялар',
      step3: 'бөлмелер',
      step4: 'шоттар',
      step5: 'есептеу жоспары',
      step6: 'абоненттердің бастапқы сальдосы'
    }
  },
  osiRegistration: {
    holdForDelete: 'жою үшін ұстап тұрыңыз',
    dragAndDropText: 'Банк қосымшасынан/сайтынан шот деректемелері бар файлды тіркеңіз'
  },
  common: {
    formFields: {
      fio: {
        label: 'ТАӘ',
        validation: {
          need: 'ТАӘ көрсетіңіз'
        }
      },
      osiName: {
        label: 'Аты',
        validation: {
          need: 'Атын енгізіңіз'
        }
      },
      IDNOSI: {
        label: 'МИБ БСН / ИИН',
        validation: {
          need: 'БСН / ИИН көрсетіңіз',
          tooShort: 'БСН / ИИН толық көрсетілмеген',
          error: 'БСН / ИИН қате көрсетілген'
        }
      },
      fioChairman: {
        label: 'Төрағаның ТАӘ',
        validation: {
          need: 'Төрағаның ТАӘ көрсетіңіз'
        }
      },
      iin: {
        label: 'БСН / ИИН',
        validation: {
          tooShort: 'БСН / ИИН толық көрсетілмеген',
          error: 'БСН / ИИН қате көрсетілген',
          need: 'БСН / ИИН көрсетіңіз'
        }
      },
      phone: {
        label: 'Байланыс телефоны',
        validation: {
          tooShort: 'Нөмір толық көрсетілмеген',
          error: 'Нөмір қате көрсетілген',
          need: 'Байланыс телефонын көрсетіңіз'
        }
      },
      email: {
        label: 'Email',
        validation: {
          error: 'Дұрыс электрондық поштаны көрсетіңіз'
        }
      },
      constructionYear: {
        label: 'Салынған жылы',
        validation: {
          need: 'Салынған жылын көрсетіңіз',
          min: 'Минималды салынған жылы 1800',
          max: 'Құрылыстың максималды жылы ағымдағы'
        }
      },
      constructionMaterial: {
        label: 'Үй түрі',
        validation: {
          need: 'Үй түрін көрсетіңіз'
        }
      },
      houseState: {
        label: 'Үйдің жағдайы',
        validation: {
          need: 'Үйдің жағдайын көрсетіңіз'
        }
      },
      floorCount: {
        label: 'Қабаттар саны',
        validation: {
          need: 'Едендер санын көрсетіңіз',
          error: 'Дұрыс еденді көрсетіңіз',
          max: 'Ең көбі 100 қабат'
        }
      },
      number: {
        label: 'Нөмірі',
        validation: {
          need: 'Нөмірді көрсетіңіз'
        }
      },
      flatType: {
        label: 'Бөлме түрі',
        validation: {
          need: 'Бөлменің түрін көрсетіңіз'
        }
      },
      parentAbonent: {
        label: 'Ата-аналық бөлме',
        validation: {
          need: 'Тұрақ пен қойма үшін ата-аналық бөлмеге байланыстыру міндетті'
        }
      },
      flat: {
        label: 'Үй-жай',
        validation: {
          need: 'Бөлмені көрсетіңіз'
        }
      },
      floor: {
        label: 'Қабат',
        validation: {
          need: 'Еденді көрсетіңіз'
        }
      },
      square: {
        label: 'Алаң',
        validation: {
          need: 'Аумақты көрсетіңіз'
        }
      },
      effectiveSquare: {
        label: 'пайдалы алаң',
        validation: {
          need: 'пайдалы аймақты көрсетіңіз'
        }
      },
      owner: {
        label: 'Меншік иесі',
        labelAlt: 'Иесі',
        validation: {
          need: 'Меншік иесін көрсетіңіз'
        }
      },
      service: {
        label: 'Қызмет',
        validation: {
          need: 'Қызметті көрсетіңіз'
        }
      },
      accrualType: {
        label: 'Қызметті есептеу әдісі',
        validation: {
          need: 'Қызметті есептеу әдісін көрсетіңіз'
        }
      },
      tariff: {
        label: 'Тариф',
        validation: {
          need: 'тарифті көрсетіңіз',
          positive: 'мән 0-ден үлкен болуы керек'
        }
      },
      arendator: {
        label: 'Жалға алушы',
        validation: {
          need: 'Жалға алушыны көрсетіңіз'
        }
      },
      month: {
        label: 'Ай',
        validation: {
          need: 'Айды көрсетіңіз'
        }
      },
      fromMonth: {
        label: 'Бір айдан бастап',
        validation: {
          need: 'Айды көрсетіңіз'
        }
      },
      toMonth: {
        label: 'айына',
        validation: {
          need: 'Айды көрсетіңіз'
        }
      },
      selectFlat: {
        label: 'Үй-жайды таңдау',
        validation: {
          need: 'Бөлме таңдауын көрсетіңіз'
        }
      },
      selectNotify: {
        label: 'Хабарландыруды таңдау',
        validation: {
          need: 'Хабарландыруды таңдаңыз'
        }
      },
      fromDate: {
        label: 'Бастап',
        validation: {
          need: 'Күннен бастап көрсетіңіз'
        }
      },
      toDate: {
        label: 'Дейін',
        validation: {
          need: 'Күні бойынша көрсетіңіз'
        }
      },
      serviceGroup: {
        label: 'Қызметтер тобы',
        validation: {
          need: 'Қызметтер тобын көрсетіңіз'
        }
      },
      room: {
        label: 'Үй-жай',
        validation: {
          need: 'Бөлмені көрсетіңіз'
        }
      },
      sum: {
        label: 'Сома',
        validation: {
          need: 'Соманы көрсетіңіз'
        }
      },
      reason: {
        label: 'Мақсаты',
        validation: {
          need: 'Тағайындауды көрсетіңіз',
          min: 'тағайындауды толығырақ көрсетіңіз'
        }
      },
      paymentDate: {
        label: 'төлем күні',
        validation: {
          need: 'төлем күнін көрсетіңіз'
        }
      },
      name: {
        label: 'атауы',
        validation: {
          need: 'атауын көрсетіңіз'
        }
      },
      monthSum: {
        label: 'бір айдағы сома, тг',
        validation: { need: ' бір айдағы соманы көрсетіңіз' }
      },
      address: {
        label: 'Мекен-жайы',
        validation: { need: ' мекенжайды көрсетіңіз' }
      },
      ats: {
        label: 'елді мекен',
        validation: { need: ' елді мекенді көрсетіңіз' }
      },
      geonim: {
        label: 'көше',
        validation: { need: ' көшені көрсетіңіз' }
      },
      building: {
        label: 'құрылым',
        validation: { need: ' құрылымды көрсетіңіз' }
      },
      livingFact: {
        label: 'тұрады'
      },
      livingJur: {
        label: 'тіркелген'
      },
      flatCount: {
        label: 'бөлмелер саны',
        validation: {
          tooShort: 'кем дегенде 2 орынды көрсетіңіз',
          tooBig: 'кіші санды көрсетіңіз',
          need: 'үй-жайлардың/пәтерлердің санын көрсетіңіз'
        }
      },
      unionType: {
        label: 'біріктіру түрі',
        validation: {
          need: 'біріктіру түрін көрсетіңіз'
        }
      },
      companyType: {
        label: 'компания түрі',
        validation: {
          need: 'компания түрін көрсетіңіз'
        }
      },
      billType: {
        label: 'шот түрі',
        validation: {
          need: 'шот түрін көрсетіңіз'
        }
      },
      bill: {
        label: 'негізгі есеп айырысу шоты',
        validation: {
          need: 'шот нөмірін көрсетіңіз',
          tooShort: 'шот толық тізімде жоқ',
          error: 'шот дұрыс көрсетілмеген'
        }
      },
      IDNBank: {
        label: 'BIC Bank',
        validation: {
          need: 'Банктің бИК-ін көрсетіңіз',
          tooShort: 'бИК-ін Банктің толық тізімде жоқ',
          error: 'Банктің БИКІ дұрыс емес'
        }
      }
    },
    registration: 'Тіркелу',
    register: 'Тіркелу',
    login: 'Кіру',
    copyright: 'Барлық құқықтар қорғалған',
    settings: 'Параметрлер',
    theme: 'Тақырып',
    color: 'Түс',
    size: 'Көлемі',
    language: 'Тіл',
    fullScreen: 'Толық экранда',
    standard: 'Стандартты',
    back: 'Артқа',
    rememberMe: 'мені есте сақтау',
    forgetPassword: 'Құпия сөзіңізді ұмыттыңыз ба',
    check: 'Тексеру',
    menu: 'Мәзір',
    welcome: 'Қош келдіңіз',
    save: 'Сақтау',
    exit: 'Шығу',
    myProfile: 'Менің профилім',
    add: 'Қосу',
    download: 'Жүктеу',
    total: 'Барлығы',
    cancel: 'Бас тарту',
    delete: 'Жою',
    accepted: 'Келісемін',
    close: 'Жабу',
    begin: 'Басталуы',
    refresh: 'Жаңарту',
    select: 'Таңдау',
    print: 'Басып шығару',
    next: 'келесі',
    finish: 'аяқтау',
    empty: 'жоқ',
    howToUse: 'Толтыру жөніндегі Нұсқаулық',
    clickMe: 'Мені басыңыз',
    filled: 'толтырылды',
    finesSwitch: 'Өсімпұлды есептеуді қосу',
    success: 'Сәтті'
  }
};
